import useValidator from '../../../../utilities/useValidator';
import validators from '../../../../utilities/validators';

const validator = validators.compose(
    validators.requiredString('identifier'),
    validators.requiredString('name.defaultValue'),
    validators.requiredString('bodyType'),
    validators.requiredNumber('order'),
    validators.requiredBoolean('isActive')
);

const useSubmodelValidator = () => useValidator(validator);

export default useSubmodelValidator;
